import styled from 'styled-components';

export const StyledUSerPanelRoleElements = styled.div`
    width: 100%;
`;
